import type { FC } from 'react'

import { Tooltip } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { getWhiteLabelForDealerStyle } from '@skytech/utils'
import ContentCopyIcon from 'mdi-react/ContentCopyIcon'

import { useAppContext } from '@/App.context'
import { useTranslation } from '@/components/i18n/hooks'

export const ClipboardButton: FC<{ text: string }> = ({ text }) => {
  const { whiteLabel } = useAppContext()
  const translate = useTranslation()
  return (
    <Button
      size="2xs"
      variant="tertiary"
      Icon={<ContentCopyIcon />}
      className="m-0 mb-2 ml-1 p-0"
      data-tooltip-id="copy"
      data-tooltip-content={translate('Copy')}
      data-event="click focus"
      onClick={e => {
        e.stopPropagation()
        window.navigator.clipboard.writeText(text)
      }}
      whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
    >
      <Tooltip id="copy" size="base" />
    </Button>
  )
}
